import React, { Fragment, useState, useEffect } from "react"
import { useSelector } from "react-redux"
import Tooltip from "@material-ui/core/Tooltip"
import { Typography, makeStyles, useTheme } from "@material-ui/core"
import CircularProgress from "@material-ui/core/CircularProgress"

const useStyles = makeStyles((theme) => ({
	btnWrapper: {
		display: "inline-flex",
		alignItems: "center",
		gap: "5px",
	},
}))

const ElementsButton = ({ viewItemsBtn, setViewItemsBtn, setNeedToFilter, counterDocs, setCounterDocs, isLoading = false }) => {
	const classes = useStyles()
	const theme = useTheme()
	/* ******************* REDUX STORE ******************* */
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const searching_doc = useSelector((state) => state.buildconcept.searching_doc)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	/* ******************* REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		if (conceptDocs.count === 0) {
			setCounterDocs("")
		} else {
			setCounterDocs(conceptDocs.count) // This line makes counterDocs value is always empty. Remove this to show real docs number.
		}
	}, [conceptDocs.count])
	/* ******************* END USE-EFFECTS ******************* */

	return (
		<Tooltip
			title={
				<Fragment>
					<Typography color="inherit">Documents</Typography>
					{"View the document in detail. You can download, identify by priority and highlight text."}
				</Fragment>
			}
			placement="bottom"
			arrow
		>
			<button
				data-cy="docs_button"
				onClick={(e) => {
					e.preventDefault()
					setViewItemsBtn("files")
					setNeedToFilter(true)
				}}
				className={`${classes.btnWrapper} ${
					viewItemsBtn === "files"
						? "btn btn-primary  btnViewsFilterBuild btn-small-filter ml-2"
						: "btn btn-outline-primary  btnViewsFilterBuild btn-small-filter ml-2"
				}`}
			>
				{/* {searching_doc === true? <span><div className="spinner-border ms-auto spinner-docs" role="status" aria-hidden="true"></div></span>  : <span data-cy="numdocs">{counterDocs} </span> } */}
				{isLoading ? (
					<CircularProgress color="secondary" style={{ width: 15, height: 15 }} />
				) : (
					counterDocs && <span data-cy="numdocs">{counterDocs} </span>
				)}
				<i className="bi bi-search"></i>
				<i className="bi bi-file-earmark-bar-graph"></i>
			</button>
		</Tooltip>
	)
}

export default ElementsButton
